export default class SelectControl {
  constructor({
    selectOptions,
    title,
    onChange,
    textField = 'text',
    valueField = 'value',
    value = null,
    iconCss = null
  }) {
    const select = document.createElement("select");
    select.title = title;
    select.classList.add("form-control");
    selectOptions.forEach((opt) => {
      const option = new Option(opt[textField], opt[valueField]);
      select.appendChild(option);
    });
    if (value != null) select.value = value;
    select.addEventListener("change", onChange);

    this._select = select;
    this._iconCss = iconCss;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement("div");
    this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._formGroup());
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }

  enable() {
    this._select.disabled = false;
  }

  disable() {
    this._select.disabled = true;
  }

  _formGroup() {
    const inputGroup = this._div("input-group", "input-group-sm");

    if (this._iconCss) {
      const inputPrepend = this._div("input-group-prepend");
      inputPrepend.innerHTML = `
        <div class="input-group-text bg-white p-1">
          <i class="${this._iconCss}"></i>
        </div>
      `;
      inputGroup.appendChild(inputPrepend);
    }

    inputGroup.appendChild(this._select);
    return inputGroup;
  }

  _div(...classNames) {
    const div = document.createElement("div");
    div.classList.add(...classNames);
    return div;
  }
}
